export default __webpack_public_path__ + "static/media/comment.f13efe0b.svg";